import {
  commonMutationTypes,
  commonPaginationTypes,
  OrderDirection,
  pageInfo,
} from "../../../../../../utils/commonQueryTypes";

export enum AtsStckUoMOrderField {
  CREATED_AT = "CREATED_AT",
  UOM = "UOM",
  SL_NO = "SL_NO",
}

export interface GetStockUoMVars extends commonPaginationTypes {
  customer_id: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsStckUoMOrderField;
  };
  name: string;
}

export interface AtsStckUoM {
  id: number;
  uom: string;
  slNo: number;
  uomDesc: string;
  useDecimals: boolean;
  decimalNos: number;
  customerID: number;
}

export interface AtsStckUoMEdge {
  node: AtsStckUoM;
  cursor: string;
}

interface GetStockUoMData {
  edges: AtsStckUoMEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetStockUoMResult {
  GetStockUoM: GetStockUoMData;
}

//Mutations

export interface CreateAtsStckUoMInput {
  uom: string;
  uomDesc: string;
  useDecimals: boolean;
  decimalNos: number;
}

export interface AddStockMoUVar extends commonMutationTypes {
  customer_id: number;
  input: CreateAtsStckUoMInput;
}

export interface AddStockMoUResult {
  AddStockUoM: boolean;
}

export interface UpdateStockMoUVar extends commonMutationTypes {
  uom_id: number;
  input: CreateAtsStckUoMInput;
}

export interface UpdateStockMoUResult {
  UpdateStockUoM: boolean;
}

export interface DeleteUomByIdResult{
  DeleteStockUoM:boolean;
}

export interface DeleteUomByIdVars extends commonMutationTypes{
  uom_id:number;
}